import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processGoogleAuth = async () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        navigate('/login', { replace: true });
        return;
      }

      // Check for invite token in localStorage (set before redirect)
      const inviteToken = localStorage.getItem('pipeguide_invite_token');

      try {
        const { data } = await axios.post(
          `${API}/auth/google/session`,
          { session_id: sessionId, invite_token: inviteToken },
          
        );

        // Clear invite token
        if (inviteToken) localStorage.removeItem('pipeguide_invite_token');

        // Store tokens for Bearer auth
        if (data.token) localStorage.setItem('pg_token', data.token);
        if (data.refresh_token) localStorage.setItem('pg_refresh_token', data.refresh_token);

        // Clear hash from URL
        window.history.replaceState(null, '', window.location.pathname);

        setUser(data);
        navigate('/', { replace: true });
      } catch (e) {
        console.error('Google auth failed:', e);
        navigate('/login', { replace: true, state: { error: 'Google sign-in failed. Please try again.' } });
      }
    };

    processGoogleAuth();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-brand-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-zinc-500">Signing you in...</p>
      </div>
    </div>
  );
}
